import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Horse } from '../models/horse';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class HorseService {

  constructor(private http: HttpClient) { }

  get(id: string): Promise<Horse> {
    return this.getWithRest('id/' + id);
  }

  private getWithRest(rest_url: string) : Promise<Horse> {
    return new Promise((resolve, reject) => {
      return this.http.get(AppSettings.API_ENDPOINT + 'horses/' + rest_url).subscribe((response:any) => {

        if(response.type == 'user_horse' && response.data){
          resolve(response.data);
        } else {
          reject(response);
        }

      },
        error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
    });
  }

getList(): Promise<Horse[]> {
	return this.getListWithRest("");
}
/*
  private getListWithRest(rest_url: string) : Promise<Horse[]> {
  	return new Promise((resolve, reject) => {
		return this.http.get(AppSettings.API_ENDPOINT + 'horses/' + rest_url).subscribe((response:any) => {
			if(response.type == 'user_horses' && response.data){
				resolve(response.data);
			} else {
				reject(response);
			}

		},
			error_response => {
	      		if(error_response instanceof HttpErrorResponse){
	      			reject(error_response.error);
	      		}
	      		reject(error_response);
			});
	});
  }
  */
 private getListWithRest(url: string) : Promise<Horse[]> {
   return new Promise((resolve, reject) => {
     return this.http.get(AppSettings.API_ENDPOINT + "horses/user").subscribe({
       next: (response:any) => {
         if(response.data && response.type == 'user_horses'){
           resolve(response.data);
         } else {
           reject(response);
         }
       },
       error: (error_response) => {
         if(error_response instanceof HttpErrorResponse){}
       }

     });
   });
 }

  create(horse: Horse): Promise<Horse> {

    let post_data = {
        data: {
          type: 'horse',
          attributes: { horse: horse }
          }
      };

    	return new Promise((resolve, reject) => {

            return this.http.post(AppSettings.API_ENDPOINT + 'horses',
                post_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && (response.type=='horse' || response.type=='user_horse' || response.type == 'organizer_horse')) {
                       resolve(response.data);
                       }  else {
                         reject(response);
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error);
                  }
                });
            });
    }

    update(horse: Horse): Promise<Horse> {

    let put_data = {
        data: {
          type: 'horse',
          attributes: { horse: horse }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.put(AppSettings.API_ENDPOINT + 'horses',
                put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && (response.type=='horse' || response.type=='user_horse' || response.type == 'organizer_horse')) {
                       resolve(response.data);
                       }  else {
                         reject(response);
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error);
                  }
                });
            });
    }

 hide(horse: Horse): Promise<boolean> {
    let put_data = {
        data: {
          type: 'horse_hide_request',
          attributes: { id: horse.id }
          }
      };

      return new Promise((resolve, reject) => {

            return this.http.put(AppSettings.API_ENDPOINT + 'horses',
                put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
                     if(response.data && response.type=='horse_hide_response') {
                         resolve(response.data);
                       }  else {
                       if(response.text){
                           reject(response.text);
                         } else {
                          reject(response);
                        }
                       }

                }, error => {
                  if(error instanceof HttpErrorResponse){
                    reject(error.error);
                  } else {
                    reject(error);
                  }
                });
            });
  }



}


